import { combineReducers } from 'redux';
import login from 'components/login/actions';
import address from 'components/address/actions';
import product from 'components/product/actions';
import recommendation from 'components/recommendation/actions';
import cart from 'components/cart/actions';
import search from 'components/search/actions';
import category from 'components/category/actions';
import categoryGroup from 'components/categoryGroup/actions';
import filter from 'components/filter/actions';
import checkout from 'components/checkoutPage/actions';
import payment from 'components/payment/actions';
import promo from 'components/promo/actions';
import orderTracking from 'components/orderTracking/actions';
import orderHistory from 'components/orderHistory/actions';
import link from 'components/link/actions';
import home from 'components/home/actions';
import app from 'components/app/actions';
import bartender from 'components/bartender/actions';
import userAddresses from 'components/userAddresses/actions';
import brands from 'components/brands/actions';
import gifting from 'components/gifting/actions';
import availability from 'components/availability/actions';
import substitutions from 'components/substitutions/actions';

export default combineReducers({
  login,
  address,
  product,
  recommendation,
  cart,
  search,
  category,
  categoryGroup,
  filter,
  checkout,
  payment,
  promo,
  orderTracking,
  orderHistory,
  link,
  home,
  app,
  bartender,
  userAddresses,
  brands,
  gifting,
  availability,
  substitutions
});



// WEBPACK FOOTER //
// ./shared/stores/reducers.js